// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sMBlcOnOSvNBQ5 {
  text-align: center;
  vertical-align: middle;
}
.VXXRxDWP9f8Dcm {
  margin-bottom: var(--ds-space-0, 0);
}
.m7IzuqIIYptwTu {
  border-bottom: 1px dashed var(--ds-text-subtlest, #626f86);
  cursor: pointer;
}
`, ""]);
// Exports
export var featureCell = `sMBlcOnOSvNBQ5`;
export var cellText = `VXXRxDWP9f8Dcm`;
export var underlineAuto = `m7IzuqIIYptwTu`;
export default ___CSS_LOADER_EXPORT___;
